import { Button, Divider, Input, Popover } from "antd";
import TableFetchData from "../../components/data-table/TableFetchData";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../utils/dateFormatUtils";
import DateRangeComponent from "../../components/date/DateRangeComponent";
import SearchSvg from "../../assets/images/SearchSvg";
import { IoCopyOutline } from "react-icons/io5";
import ShippingModal from "../../components/magazine/ShippingModal";
import { useState } from "react";
import { ExportExcelSvg } from "../../assets/images/HeaderSvg";
import AirlyPaySvg from "../../assets/images/AirlyPay";
import WeChatSvg from "../../assets/images/WeChat";

const TablePendingShipment = ({
    loading, setLoading,
    paymentData,keyword, setKeyword, 
    dates, setDates, initLoadOrder,
    tableParams, setTableParams,
    messageModalRef, showAddress,
    exportOrder, 
}) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen]= useState(false)
    const [shippedId, setShippedId]= useState("")
    
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                messageModalRef.current.showSuccessConfirmsAutoClose(t("Copied Successfully"), () => { }, "", true);
            })
            .catch(() => {
                messageModalRef.current.showWarningConfirmsAutoClose(`Failed to copy!`, () => { }, "", true);
            });
    };

    const getOrderTotalAmount = (record) => {
        if (record?.totalAmount !== undefined && record?.totalAmount !== null) return record.totalAmount;
        if (record?.total !== undefined && record?.total !== null) return record.total;
        if (record?.amount !== undefined && record?.amount !== null) return record.amount;
        if (Array.isArray(record?.items) && record.items.length > 0) {
            return record.items.reduce((acc, item) => {
                const itemTotal = item?.subTotal !== undefined 
                    ? Number(item.subTotal) 
                    : (Number(item?.unitPrice || 0) * Number(item?.qty || 1));
                return acc + itemTotal;
            }, 0);
        }
        return 0;
    };

    const tableSettings = {
        appendable: false,
        removable: false,
        bordered: true,
        size: "small",
        pagination: {
            showLessItems: true,
            showSizeChanger: false,
            pageSize: 10,
        },
        columns: [
            {
                title: <label className="titleCard14400">{t('Order Num')}</label>,
                render: (_, record) => (
                    <label className="">{record && record.orderId}</label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Product Name')}</label>,
                render: (_, record) => (
                    <label className="">{record && record.items && record?.items?.map((pro) =>(
                        <div className="d-flex">
                            <div>{pro?.productName}</div>
                            <span style={{ color: "#bdbdbd", marginLeft:"0.5rem" }}> x{pro && pro?.qty}</span>
                        </div>
                    ))}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('User Id')}</label>,
                render: (_, record) => (
                    <Popover
                        content={
                            <div style={{ padding: "4px 2px", minWidth: "180px", fontSize: "13px" }}>{console.log("record", record)}
                                <div style={{ marginBottom: "6px" }}>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("User's Name")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>{record?.memberId?.name || t("N/A")}</span>
                                </div>
                                <div style={{ marginBottom: "6px" }}>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("Phone Number")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>
                                        {record?.memberId?.phone?.countryCode && record?.memberId?.phone?.number
                                            ? `(${record.memberId.phone.countryCode}) ${record.memberId.phone.number}`
                                            : null}
                                    </span>
                                </div>
                                <div>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("Email Address")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>{record?.memberId?.email || t("N/A")}</span>
                                </div>
                            </div>
                        }
                        trigger="hover"
                    >
                        <label className="" style={{color:"#0d6efd", cursor: "pointer"}}>{record && record.memberNo}</label>
                    </Popover>
                    
                ),
            },
            {
                title: <label className="titleCard14400">{t('Payment Amount')}</label>,
                render: (_, record) => (
                    <label className="">
                        {`￥${getOrderTotalAmount(record)}`}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Receiving Introduction')}</label>,
                render: (_, record) => (
                    <label>
                        {showAddress(record && record?.shippingInfo)}
                        <IoCopyOutline
                            color="#bdbdbd"
                            style={{ cursor: "pointer", marginLeft: 8 }}
                            onClick={() => handleCopy(showAddress(record?.shippingInfo))}
                        />
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Order Status')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {record && record?.shippingInfo?.status ==="pending" ? "已付款待发货" :"已付款待发货" || ""}
                    </label>
                ),
            },
            {
                title: <label className="ant-table-column-title titleCard14400">{t('Payment Time')}</label>,
                dataIndex: 'paymentTS',
                sorter: true,
                key: 'paymentTS',
                render: (_, record) => (
                    <>
                        {record && record.paymentTS ? formatDateTime(record.paymentTS) : ""}
                    </>
                )
            },
            {

                title: <label className="titleCard14400">{t('Payment Portal')}</label>,
                render: (_, record) => {
                    if (record && record?.paymentId?.method === 'alipay') {
                        return <AirlyPaySvg />;
                    } else if (record && record?.paymentId?.method === 'wechatpay') {
                        return <WeChatSvg />;
                    } else {
                        return (
                            <label className="text-capitalize">
                                {t(record && record?.paymentId?.method)}
                            </label>
                        );
                    }
                },
            },
            {
                title: <label className="titleCard14400">{t('Operator')}</label>,
                render: (_, record) => (
                    <div
                        onClick={() => {
                            setModalOpen(true);
                            setShippedId(record?._id || record?.id);
                        }}
                        style={{color:"#1a5fff", cursor:"pointer"}}
                        className="text-capitalize"
                    >
                        {t("Shipping")}
                    </div>
                ),
            }
        ],
    };

    return (
        <>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                        <Input
                            placeholder={t("Search")}
                            prefix={<SearchSvg style={{ color: '#8c8c8c' }} />}
                            size="large"
                            className='me-3 col-7'
                            disabled={loading}
                            loading={loading}
                            allowClear
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        <DateRangeComponent
                            className="col-4 me-4"
                            placeholder={t("Please select a time or time period")}
                            disabled={loading}
                            value={dates ? dates : [null, null]}
                            setValue={setDates}
                            style={{ width: "40%" }}
                        />
                    </div>
                    <div className="d-flex align-items-center">
                        <Button
                            size="large"
                            onClick={() => {
                                setTableParams({
                                    ...tableParams,
                                    pagination: {
                                        ...tableParams.pagination,
                                        current: 1,
                                    },
                                });
                                initLoadOrder();
                            }}
                        >
                            {t('Query')}
                        </Button>
                        <Divider type="vertical" style={{ height: '40px', borderColor: '#d9d9d9' }} />
                        <div onClick={() => exportOrder()} style={{ cursor: "pointer" }}>
                            <ExportExcelSvg />
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <TableFetchData
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    data={paymentData}
                    columns={tableSettings.columns}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
            <ShippingModal 
                modalOpen={modalOpen} setModalOpen={setModalOpen} 
                shippedId={shippedId} setShippedId={setShippedId}
                loadingNew={loading} setLoading={setLoading}
                handleCopy={handleCopy} isShipped={false}
                initLoadOrder={initLoadOrder} showAddress={showAddress}
            />
        </>
    );
};

export default TablePendingShipment;
